module.exports = __webpack_public_path__ + "static/img/tcqn8.fb50410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tcqn8.png
// module id = 387
// module chunks = 0